import ApiController from './ApiController';
import PermissaoController from './PermissaoController';

class ClienteAvaliadorController {

    constructor() {
        this.apiController = new ApiController();
        this.permissaoController = new PermissaoController();
    }

    /**
     * Atribui um cliente a um avaliador
     * @param {Number} idCliente ID do cliente
     * @param {Number} idAvaliador ID do avaliador
     * @returns {Object} Resultado da operação
     */
    async atribuir(idCliente, idAvaliador) {
        const erros = this._validarAtribuicao(idCliente, idAvaliador);

        if (erros.length > 0)
            return { sucesso: false, erros };

        try {
            const body = {
                idCliente: idCliente,
                idAvaliador: idAvaliador
            };

            const { data: result } = await this.apiController.post('/cliente-avaliador/atribuir', body);
            return {
                sucesso: true,
                data: result
            };
        } catch (error) {
            return { sucesso: false, erros: error.response?.data || [{ mensagem: error.message }] };
        }
    }

    /**
     * Atribui e desatribui múltiplos clientes a um avaliador
     * @param {Number} idAvaliador ID do avaliador
     * @param {Array<Number>} clientesParaAdicionar Array de IDs dos clientes para adicionar
     * @param {Array<Number>} clientesParaRemover Array de IDs dos clientes para remover
     * @returns {Object} Resultado da operação
     */
    async atribuirMultiplos(idAvaliador, clientesParaAdicionar = [], clientesParaRemover = []) {
        const erros = this._validarAtribuicaoMultipla(idAvaliador, clientesParaAdicionar, clientesParaRemover);

        if (erros.length > 0)
            return { sucesso: false, erros };

        try {
            const body = {
                idAvaliador: idAvaliador,
                clientesParaAdicionar: clientesParaAdicionar,
                clientesParaRemover: clientesParaRemover
            };

            const { data: result } = await this.apiController.post('/cliente-avaliador/atribuir-multiplos', body);
            return {
                sucesso: true,
                data: result
            };
        } catch (error) {
            return { sucesso: false, erros: error.response?.data || [{ mensagem: error.message || 'Erro na operação em lote' }] };
        }
    }

    /**
     * Lista os clientes atribuídos a um avaliador
     * @param {Number} idAvaliador ID do avaliador
     * @returns {Object} Resultado da operação
     */
    async listarClientesDoAvaliador(idAvaliador) {
        if (!idAvaliador) {
            return { sucesso: false, erros: [{ mensagem: 'ID do avaliador não informado' }] };
        }

        try {
            const { data: result } = await this.apiController.get(`/cliente-avaliador/avaliador/${idAvaliador}`);
            // O backend retorna diretamente a lista de clientes, ajustamos para o formato padrão { sucesso: true, items: [...] }
            return {
                sucesso: true,
                items: result
            };
        } catch (error) {
            return { sucesso: false, erros: error.response?.data || [{ mensagem: error.message || 'Erro ao listar clientes do avaliador' }] };
        }
    }

    /**
     * Valida os dados para atribuição múltipla
     * @param {Number} idAvaliador ID do avaliador
     * @param {Array<Number>} clientesParaAdicionar Array de IDs dos clientes para adicionar
     * @param {Array<Number>} clientesParaRemover Array de IDs dos clientes para remover
     * @returns {Array} Lista de erros
     */
    _validarAtribuicaoMultipla(idAvaliador, clientesParaAdicionar, clientesParaRemover) {
        const erros = [];

        if (!idAvaliador)
            erros.push({ campo: 'idAvaliador', mensagem: 'É necessário informar o avaliador' });

        if ((!clientesParaAdicionar || clientesParaAdicionar.length === 0) &&
            (!clientesParaRemover || clientesParaRemover.length === 0)) {
            erros.push({ campo: 'geral', mensagem: 'É necessário selecionar pelo menos um cliente para adicionar ou remover' });
        }

        return erros;
    }
}

export default ClienteAvaliadorController;